import { errorHandler } from "./errorHandler";
import { ResetPasswordData } from "../interface";
import { apiRequest } from "./apiRequest";

export const resetPassword = async (
  args: ResetPasswordData
): Promise<string> => {
  try {
    const data = await apiRequest<{ message: string }>(
      "post",
      `/auth/reset-password`,
      { data: args }
    );

    return data.message;
  } catch (error) {
    errorHandler(error);
    throw new Error("Failed to reset password");
  }
};
